import React, { useCallback, useEffect, useRef, useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import Login from "../../app/auth/Login";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const Home = () => {
  const [fileName, setFileName] = useState(""); // State to store file name
  const [file, setFile] = useState(null); // Store selected file
  const [uploading, setUploading] = useState(false); // Track upload status
  const [message, setMessage] = useState(""); // Store success/error message
 const navigate = useNavigate()
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0]); // Store file
      setFileName(acceptedFiles[0].name); // Set the file name
      setMessage(""); // Clear previous messages
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "application/pdf": [] }, // Restrict to PDFs only
    multiple: true, // Allow only one file at a time (optional)
  });

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a PDF file first.");
      return;
    }

    const formData = new FormData();
    formData.append("pdf", file); // Key should match the backend API

    try {
      setUploading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PYTHON_BACKEND_URL}/analyze`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );


      if(response.status === 200){
        setMessage(`Upload successful: ${response.data.message}`);
        console.log(response.data.responseID)
        navigate(`/details?responseID=${response.data.responseID}`)

      }

    } catch (error) {
      setMessage("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <AuthenticatedTemplate>
        <div
          id="homePage"
          style={{ overflow: "hidden", height: "var(--app-height)" }}
        >
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />

              <div id="mainHome">
                <div
                  style={{
                    height: "100%",
                    alignContent: "baseline",
                    alignItems: "baseline",
                    textAlign: "center",
                    gap: "2rem",
                    display: "grid",
                    width: "90%",
                    margin: "auto",
                  }}
                >
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "700",
                      marginTop: "1rem",
                    }}
                  >
                    Upload Your PDF File{" "}
                  </div>
                  <div
                    {...getRootProps()}
                    style={{
                      border: "2px dashed #bb1ccc",
                      borderRadius: "8px",
                      padding: "5rem",
                      textAlign: "center",
                      backgroundColor: "#f8f9fa",
                      cursor: "pointer",
                    }}
                  >
                    <input {...getInputProps()} />
                    <CloudUploadIcon sx={{ fontSize: 50, color: "#bb1ccc" }} />
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      Drop your File here or{" "}
                      <span style={{ color: "#bb1ccc", cursor: "pointer" }}>
                        browse
                      </span>
                      .
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{ mt: 2, backgroundColor: "#bb1ccc" }}
                    >
                      Upload
                    </Button>

                    {/* Display File Name After Upload */}
                    {fileName && (
                      <Typography
                        variant="body1"
                        sx={{ mt: 2, color: "#bb1ccc" }}
                      >
                        File Name: {fileName}
                      </Typography>
                    )}
                  </div>

                  {file !== null && (
                    <div>
                      {/* Upload Button */}
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{
                          mt: 2,
                          marginLeft: "10px",
                          backgroundColor: "#bb1ccc",
                        }}
                        onClick={handleUpload}
                        disabled={uploading || file == null}
                      >
                        {uploading ? (
                          <CircularProgress size={24} />
                        ) : (
                          "Check Compliance"
                        )}
                      </Button>

                      {/* Success/Error Message */}
                      {message && (
                        <Typography
                          variant="body2"
                          sx={{ mt: 2, color: uploading ? "gray" : "green" }}
                        >
                          {message}
                        </Typography>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default Home;
